import { z } from 'zod';
import { FlowRunSchema, FlowRunNodeSchema } from './run.js';
import { FlowApprovalAssigneeSchema } from './nodes.js';

export const FlowWsMessageTypeSchema = z.enum([
  'flow_run:created',
  'flow_run:updated',
  'flow_run:node_updated',
  'flow_run:approval_requested',
]);
export type FlowWsMessageType = z.infer<typeof FlowWsMessageTypeSchema>;

export const FlowRunCreatedMessageSchema = z.object({
  type: z.literal('flow_run:created'),
  run: FlowRunSchema,
});

export const FlowRunUpdatedMessageSchema = z.object({
  type: z.literal('flow_run:updated'),
  run: FlowRunSchema.partial().extend({ id: z.string() }),
});

export const FlowRunNodeUpdatedMessageSchema = z.object({
  type: z.literal('flow_run:node_updated'),
  runId: z.string(),
  node: FlowRunNodeSchema,
});

export const FlowRunApprovalRequestedMessageSchema = z.object({
  type: z.literal('flow_run:approval_requested'),
  runId: z.string(),
  nodeId: z.string(),
  approvalType: z.string(),
  context: z.record(z.string(), z.unknown()).nullable().optional(),
  /** Effective targets this approval is reported to and gated on. */
  assignees: z.array(FlowApprovalAssigneeSchema).optional(),
});

export const FlowWsMessageSchema = z.discriminatedUnion('type', [
  FlowRunCreatedMessageSchema,
  FlowRunUpdatedMessageSchema,
  FlowRunNodeUpdatedMessageSchema,
  FlowRunApprovalRequestedMessageSchema,
]);
export type FlowWsMessage = z.infer<typeof FlowWsMessageSchema>;
